import axios from "axios"
import React from "react"
import { getAccessToken } from "../providers/auth.service"

export const useWebPut = <TResponse>(onCompleted?: (isSuccess: boolean, body: any) => void) => {

    const [ isLoading, setIsLoading ] = React.useState(false)
    const [ errorCode, setErrorCode ] = React.useState<number | undefined>(undefined)
    const [ responseData, setResponseData ] = React.useState<TResponse | undefined>(undefined)
    const [ isSuccess, setIsSuccess ] = React.useState(false)

    const makePutCall = async (url: string, body: any, context?: any) => {
        if (url && body && !isLoading) {
            try {
                setIsLoading(true)

                const response = await axios.request<TResponse>({
                    method: "put",
                    url,
                    headers: { Authorization: "Bearer " +  getAccessToken() },
                    data: body,
                    validateStatus: status => true
                })

                if (response.status >= 200 && response.status <= 299) {
                    setResponseData(response.data)
                    setErrorCode(undefined)
                    setIsSuccess(true)
                    onCompleted && onCompleted(true, context)
                }
                else {
                    setErrorCode(response.status)
                    setResponseData(undefined)
                    onCompleted && onCompleted(false, context)
                }

                setIsLoading(false)
            }
            catch (e) {
                setErrorCode(-1)
                setResponseData(undefined)
                setIsLoading(false)
                onCompleted && onCompleted(false, context)
            }
        }
    }

    const reset = () => {
        setErrorCode(undefined)
        setIsLoading(false)
        setResponseData(undefined)
        setIsSuccess(false)
    }
    
    return {
        isLoading,
        isSuccess,
        errorCode,
        responseData,
        start: (url: string, body: any, context?: any) => makePutCall(url, body, context),
        reset,
    }
}